import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import moment from 'moment';
import getIcon from '@/utils/getIcon';
import { t } from 'i18next';
import { useNotification } from '@/hooks/useNotification';
import { ActivityLog, ActivityLogCount, ActivityLogHeader, ActivityLogHeaderTitle, ActivityLogIcon, ActivityLogItem, ActivityLogDateTime, ActivityLogTitle, ActivityLogTag, ActivityLogDescription, ActivityLogLink } from '@/components/custom/activity';

export function CourseMonitoringLogImportant() {
  const { getNotificationsImportant, setNotificationsImportant, notificationsImportant } = useNotification();
  const client = useClient();
  const courseId = useParams().id;

  useEffect(() => {
    getNotificationsImportant(courseId);
  }, [courseId]);

  const handleNotificationRead = async notification => {
    await client.mutate(['notifications', notification.id], { unread: false });

    setNotificationsImportant(notificationsImportant);
  };

  return (
    notificationsImportant.length > 0 && (
      <ActivityLog className="mb-6">
        <ActivityLogHeader>
          <ActivityLogHeaderTitle>{t('dashboard.important')}</ActivityLogHeaderTitle>
          <ActivityLogCount>
            <strong>{notificationsImportant?.filter(item => item.unread === true).length}</strong> {t('dashboard.unreadNotifications')}
          </ActivityLogCount>
        </ActivityLogHeader>

        {notificationsImportant?.map(notification => {
          return (
            <ActivityLogItem
              key={notification.id}
              isRead={!notification.unread}
            >
              <ActivityLogIcon variant="danger">{getIcon(notification.icon)}</ActivityLogIcon>
              <ActivityLogDateTime dateTime={moment(notification?.['created-at']).toISOString()}>{moment(notification?.['created-at']).format('DD/MM/YYYY')}</ActivityLogDateTime>
              <ActivityLogTitle>
                {notification.name} <ActivityLogTag variant="class">{notification.tag}</ActivityLogTag>
              </ActivityLogTitle>
              <ActivityLogDescription>
                {notification?.body?.split('*f6$').map((body, index) => {
                  if (body[0] == '>') {
                    return (
                      <ActivityLogLink
                        key={index}
                        to={notification.url || '/'}
                        onClick={() => handleNotificationRead(notification)}
                      >
                        {body.substring(1, body.lenght)}
                      </ActivityLogLink>
                    );
                  } else {
                    return body;
                  }
                })}
              </ActivityLogDescription>
            </ActivityLogItem>
          );
        })}
      </ActivityLog>
    )
  );
}
